import { Component, OnInit, Input } from '@angular/core';

import { Partition } from '@classes/simulation/partition';
import { KpiByYear } from '@classes/simulation/kpi-by-year';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';
import { IndiceModeType } from '@enums/indice-mode-type.enum';

@Component({
    selector: 'app-datatable-edited',
    templateUrl: './datatable-edited.component.html',
    styleUrls: ['./datatable-edited.component.scss']
})
export class DatatableEditedComponent implements OnInit {
    @Input() partitions: Partition[];
    @Input() kpisByYear: KpiByYear[];
    @Input() isMJP: boolean;

    flagType = SimulationFlagType;
    indiceModeType = IndiceModeType;

    constructor() { }

    ngOnInit() {
    }
}
